import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import select2Factory from "select2"
import "select2/dist/css/select2.css"

// select2's npm package exports a UMD factory function — module.exports =
// function(root, jQuery) { ...attaches $.fn.select2...; return jQuery } —
// rather than attaching itself as a side effect of being imported. It must
// be invoked explicitly with the exact jQuery instance this file already
// imports, or $.fn.select2 never gets defined and every call throws
// "select2 is not a function". Only needs to run once per page load.
select2Factory(window, $)

// Wraps a plain <select> with Select2 for search-as-you-type filtering.
// Usage: add data-controller="select2" to any <select> (single or
// data-select2-multiple-value="true" for multi-select tags).
export default class extends Controller {
  static values = {
    multiple: { type: Boolean, default: false },
    placeholder: { type: String, default: "" }
  }

  connect() {
    this.$el = $(this.element)
    this.$el.select2({
      width: "100%",
      theme: "default",
      multiple: this.multipleValue,
      placeholder: this.placeholderValue || this.element.dataset.placeholder || null,
      allowClear: !this.element.required
    })
  }

  disconnect() {
    // select2 attaches its own DOM (a styled wrapper + dropdown) outside
    // Stimulus's normal element lifecycle — must be torn down explicitly on
    // every Turbo page visit or duplicate widgets pile up silently.
    if (this.$el && this.$el.data("select2")) this.$el.select2("destroy")
  }
}
